"use client";

import { useRouter } from "next/navigation";

import { Button } from "@heroui/button";

import { EventKeys } from "@/lib/observability/catalog";
import { EventPublisher } from "@/lib/observability/events";
import { routes } from "@/lib/routes";

interface ClearFiltersButtonProps {
  organizationSlug: string;
}

export default function ClearFiltersButton({
  organizationSlug,
}: ClearFiltersButtonProps) {
  const router = useRouter();

  const handleClearFilters = () => {
    void EventPublisher.publishEvent(EventKeys.CLEAR_FILTERS_BUTTON_CLICK, {});
    router.push(routes.org.areas(organizationSlug));
  };

  return (
    <Button color="primary" onClick={handleClearFilters}>
      Clear Filters
    </Button>
  );
}
